import React from 'react';
import './App.css';
import Avatar from './Avatar';

function App() {
  return (
    <div className="App">
      <Avatar />
    </div>
  );
}

export default App;